import { Banner, Typography } from '@forgeglobal/design-framework';

export const CustomNotificationBanner = ({ text }) => {
  return (
    <Banner severity="info">
      <Typography
        variant="body2"
        color="textPrimary"
        data-test-id="login-message">
        {text}
      </Typography>
    </Banner>
  );
};
